import React, { useEffect, useState } from "react";
import BottonToggle from "../bars/BottomToggle";
import Logoheader from "../../components/Logoheader";
import BackButton from "../bars/BackButton";
import "./profile.css";
import LostItemSvg from "../../images/lostItem.svg";
import { fetch_booking_history } from "../../actions/orderHistory";
import HotelCard from "./HotelCard";
import LostItemModal from "./components/LostItemModal";
import { ProfileHistoryPageView } from "../../utils/Analytics";

const ProfileHistory = () => {
  const [bookingList, setBookingList] = useState([]);
  const [error, setError] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const fetchBookings = async () => {
    try {
      const res = await fetch_booking_history();
      console.log(res);
      if (res.success) {
        console.log(res.data.length);
        console.log([].length);

        if (res.data.length) {
          setBookingList(res.data);
          setError("");
        } else {
          setError("No bookings found");
        }
      } else {
        setError("Something went wrong");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    ProfileHistoryPageView();
    fetchBookings();
  }, []);

  return (
    <div>
      <BottonToggle logout />
      <Logoheader />
      <div className="my-profile section-wrap pt-7 h-full relative flex flex-col items-baseline">
        <div className="flex items-center gap-4">
          <BackButton />
          <div className="heading-part">Hotel Bookings</div>
        </div>
        {error == "" ? (
          <div className="history-section mt-6 w-full">
            <div className="cards w-full flex  cursor-pointer" onClick={()=>setOpenModal(true)}>
              <img className="h-fit mr-3 mt-1" src={LostItemSvg} alt="" />
              <div>
                <div className="title">Request for lost item</div>
                <div className="para mt-2">
                  Easily submit a request to recover your lost item through our
                  app.
                </div>
              </div>
            </div>
            <div className="pb-32">
              {bookingList.map((item, i) => {
                return <HotelCard data={item} key={i} />;
              })}
            </div>
          </div>
        ) : (
          <div className="m-auto mt-64 h-screen">{error}</div>
        )}
      </div>
      {openModal ? <LostItemModal data={bookingList} hide = {()=>setOpenModal(false)}/> : null}
    </div>
  );
};

export default ProfileHistory;
